import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
import throttle from 'lodash/throttle';
var reactSelectSingleUiSettings = BASE_SINGLE_SELECT_PROPS;
var SelectReplace = function SelectReplace(_ref) {
  var name = _ref.name,
    id = _ref.id,
    value = _ref.value,
    label = _ref.label,
    options = _ref.options,
    placeholder = _ref.placeholder,
    fieldError = _ref.fieldError,
    _ref$changeEvent = _ref.changeEvent,
    changeEvent = _ref$changeEvent === void 0 ? function () {} : _ref$changeEvent,
    _ref$blurEvent = _ref.blurEvent,
    blurEvent = _ref$blurEvent === void 0 ? function () {} : _ref$blurEvent,
    _ref$mouseDownEvent = _ref.mouseDownEvent,
    mouseDownEvent = _ref$mouseDownEvent === void 0 ? function () {} : _ref$mouseDownEvent,
    _ref$focusEvent = _ref.focusEvent,
    focusEvent = _ref$focusEvent === void 0 ? function () {} : _ref$focusEvent,
    _ref$keyDownEvent = _ref.keyDownEvent,
    keyDownEvent = _ref$keyDownEvent === void 0 ? function () {} : _ref$keyDownEvent,
    _ref$touchStartEvent = _ref.touchStartEvent,
    touchStartEvent = _ref$touchStartEvent === void 0 ? function () {} : _ref$touchStartEvent,
    componentColor = _ref.componentColor,
    _ref$isSearchable = _ref.isSearchable,
    isSearchable = _ref$isSearchable === void 0 ? false : _ref$isSearchable;
  var clickedDropRef = useRef(false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropOpened = _useState2[0],
    setDropOpened = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    highLightDrop = _useState4[0],
    setHighLightDrop = _useState4[1];
  var handleScrollWindow = throttle(function () {
    setDropOpened(false);
  }, 500);
  var handleChange = function handleChange(event) {
    changeEvent(event);
    setDropOpened(false);
  };
  var handleBlur = function handleBlur(event) {
    blurEvent();
    clickedDropRef.current = false;
    setHighLightDrop(false);
    setDropOpened(false);
  };
  var handleDropFocus = function handleDropFocus() {
    focusEvent();
    if (!clickedDropRef.current) {
      setHighLightDrop(true);
    }
  };
  var handleDropMousedown = function handleDropMousedown() {
    mouseDownEvent();
    clickedDropRef.current = true;
    setDropOpened(!dropOpened);
  };
  var handleDropKeyDown = function handleDropKeyDown(e) {
    keyDownEvent();
    if (e.which === 13 || e.which === 32) {
      setDropOpened(!dropOpened);
      if (!dropOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setDropOpened(false);
    }
  };
  var handleDropTouchstart = function handleDropTouchstart(e) {
    touchStartEvent();
    var dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      setDropOpened(!dropOpened);
    }
  };
  useEffect(function () {
    if (dropOpened) {
      window.addEventListener('scroll', handleScrollWindow);
    }
    return function () {
      window.removeEventListener('scroll', handleScrollWindow);
    };
  }, [dropOpened, handleScrollWindow]);
  return /*#__PURE__*/React.createElement("div", {
    onMouseDown: handleDropMousedown,
    onTouchStart: handleDropTouchstart,
    style: {
      '--component-color': componentColor
    }
  }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    name: name,
    id: id,
    options: options,
    value: value,
    className: "\n        react-custom-select\n        ".concat(highLightDrop ? 'react-custom-select--outlined' : '', "\n        ").concat(fieldError ? 'react-custom-select--error' : '', "\n      "),
    placeholder: placeholder,
    onChange: handleChange,
    onFocus: handleDropFocus,
    onMouseDown: handleDropMousedown,
    onKeyDown: handleDropKeyDown,
    onBlur: handleBlur,
    "aria-label": label,
    "aria-labelledby": label,
    menuIsOpen: dropOpened,
    isSearchable: isSearchable
  })));
};
export default SelectReplace;